export default {
  'form.error.required': 'Campo requerido',
  'form.error.question.required': 'Debe seleccionar al menos una respuesta para cada pregunta',
  'form.error.email': 'Debe introducir una dirección de correo válida.',
  'form.error.url': 'Debe Introducir una Url Válida',
  'form.error.password.check': 'La contraseña no es válida',
  'form.error.password.match': 'Las contraseñas no coinciden',
  'form.error.file.allowedFormat': '{fileName} no es un archivo permitido.',
  'form.error.file.allowedFormats': '{fileName} no son archivos permitidos.',
  'form.error.file.duplicated': 'El archivo "{fileName}" ya existe.',
  'form.error.file.maxSize': 'El tamaño del archivo excede el máximo permitido.',
  'form.error.files.maxSize': `El tamaño de los archivos excede el máximo permitido por el campo.`,
  'form.error.empty': ' ',
  'form.error.table.required': 'Fila Número {rowNumber}',
  'form.error.fieldsValidationError': `El formulario contiene errores de validación. Por favor, revise los campos resaltados y vuelva a realizar el envío.`,
  'form.error.offline': '¡Sin conexión! Los datos del formulario se guardarán de forma local.',
  'form.error.offline2': '¡Sin conexión! No se puede enviar el formulario.',
  'form.help.online': '¡En línea! Ya puede enviar el formulario.',
  'form.help.online2': `¡En línea! Los datos guardados del formulario han sido enviados de forma automática.`,
  'form.help.maxFileSize': 'Por favor, cargue un archivo que no exceda {maxFileSize}',
  'form.help.maxFilesSize': `Por favor, cargue archivos que no exceda el limite del campo {maxFileSize}`,
  'form.error.file.upload': 'Fallo en la carga de "{fileName}"',
  'form.error.file.remove': 'Fallo en la eliminación de "{fileName}"',
  'form.error.file.parse': 'Fallo al analizar "{fileName}"',

  'input.validation.regexp': 'El valor no coincide con la expresión regular {regexp}.',
  'input.validation.url': 'El valor no es un link válido.',
  'input.validation.uuid': 'El valor no es un UUID válido.',
  'input.validation.numeric': 'Solo se permiten valores numéricos',
  'input.validation.integer': 'No se permiten valores decimales para campos enteros',
};
